import { isString } from "../types/isString";

/**
 * Format a number to a string with optional decimal places.
 */
export function formatNumber(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any,
  locale: string = "nl-NL",
  options: {
    decimals?: boolean;
    minimumFractionDigits?: number;
    maximumFractionDigits?: number;
    currency?: string;
  } = {
    decimals: true,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  },
): string {
  if (value === undefined || value === null || value === "") {
    return "";
  }

  if (isString(value)) {
    value = parseFloat(value);
  }

  if (Number.isNaN(value)) {
    return "";
  }

  const formatOptions: Intl.NumberFormatOptions = {};

  // For Dutch formatting, configure decimal places
  if (options?.decimals === false) {
    formatOptions.maximumFractionDigits = 0;
    formatOptions.minimumFractionDigits = 0;
  } else {
    formatOptions.maximumFractionDigits = options.maximumFractionDigits ?? 2;
    formatOptions.minimumFractionDigits = options.minimumFractionDigits ?? 0;
  }

  if (options?.currency) {
    formatOptions.style = "currency";
    formatOptions.currency = options.currency;
  }

  return new Intl.NumberFormat(locale, formatOptions).format(value);
}
